<template>
<div class="all">
  <div class="container" style="position: relative">
    <div class="content">
      <div class="choice-ticket">
        <div v-if="!allCalendar" class="choice-ticket__spinner">
          <half-circle-spinner
            v-if="isContentLoading"
            :animation-duration="2000"
            :size="60"
            :color="'#FFF'"
          />
        </div>
        <div v-else class="choice-ticket__wrapper">
          <div v-if="!allowedAllCalendar.length && !mhlAllCalendar.length" class="choice-ticket__no-tickets-message">
            <span>Уважаемые болельщики и гости!</span>
            <br>
            <span>Хоккейный клуб "Сочи" завершил выступление в Фонбет Чемпионате КХЛ сезона 2025/2026 годов.</span>
            <span>Благодарим вас за покупку билетов на матчи и оказанную поддержку!</span>
            <br>
            <span>Информация о сроках запуска продаж билетов и абонементов на сезон 2026/2027 годов будет объявлена позднее на официальном сайте ХК "Сочи". Следите за новостями.</span>
            <br>
            <span>До новых встреч!</span>
          </div>
          <div v-else>
            <button 
              v-if="this.userInfoId && reservedSeats && reservedSeats.length"
              type="button" 
              class="js-basket-shop basket-shop detail-page tiskets" 
              :class="{'fixed': isScrollOver, 'loading': isTicketsPopupLoading}"
              :disabled="isTicketsPopupLoading"
              @click="showTicketsPopup()"
            > 
              <half-circle-spinner
                v-if="isTicketsPopupLoading"
                class="tickets-popup-loader"
                :animation-duration="2000"
                :size="60"
                :color="'#0a275f'"
              />
              <div class="basket-shop__wrapper">
                <div class="basket-shop__selected-info">
                  <span>Выбрано:</span>
                  <span v-if="basketCalendar === 1"> {{ basketCalendar }} мероприятиe</span>
                  <span v-if="basketCalendar >= 2 && basketCalendar <= 4"> {{ basketCalendar }} мероприятия</span>
                  <span v-if="basketCalendar >= 5"> {{ basketCalendar }} мероприятий</span>
                </div>
                <div class="basket-shop__inner">
                  <div class="basket-shop__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                            d="M19.99 6.59c.04-.32-.03-.6-.2-.83a.98.98 0 00-.7-.44L5.26 3.72l-.18-1.75c-.03-.21-.1-.4-.23-.57a.94.94 0 00-.47-.35l-3.05-1a1.04 1.04 0 00-.78.07 1 1 0 00-.52.63c-.07.3-.05.57.08.83.12.26.33.44.6.53l2.39.78.84 8.77-.56 3.13c-.04.33.04.63.25.9a1 1 0 00.8.38h12.88a1 1 0 00.73-.3c.2-.21.3-.47.3-.78 0-.3-.1-.56-.3-.77a1 1 0 00-.73-.3H5.67l.24-1.43h12.22c.25 0 .48-.08.68-.25.2-.17.3-.39.34-.65l.84-5zm-14 10.08c.45 0 .82.16 1.13.48.31.32.47.71.47 1.17 0 .46-.16.86-.47 1.19-.3.33-.68.49-1.12.49-.44 0-.82-.16-1.13-.5-.3-.32-.46-.72-.46-1.18A1.63 1.63 0 016 16.67zm10.55.48a1.5 1.5 0 00-1.12-.48c-.44 0-.82.16-1.13.48-.3.32-.46.71-.46 1.17 0 .46.16.86.46 1.19.31.33.69.49 1.13.49.44 0 .82-.16 1.12-.5.31-.32.47-.72.47-1.18 0-.46-.16-.85-.47-1.17z"
                            clip-rule="evenodd"></path>
                    </svg>
                  </div>
                  <div class="basket-shop__text basket-shop__text--margin">
                    <span class="tablet-hide">В&nbsp;корзине:</span>
                    <span>{{ basketQuantity }} 
                      <span v-if="basketQuantity === 1" class="tablet-hide">билет</span>
                      <span v-if="basketQuantity >= 2 && basketQuantity <= 4" class="tablet-hide">билета</span>
                      <span v-if="basketQuantity >= 5" class="tablet-hide">билетов</span>
                    </span>
                  </div>
                  <div class="basket-shop__text tablet-hide">
                    <span>на&nbsp;сумму:</span>
                    <span>{{ basketPrice }} ₽</span>
                  </div>
                </div>
                <!-- <div class="basket-shop__info tablet-hide">
                    <span>Оформить заказ</span>
                    <svg>
                        <use xlink:href="#ic_arrow-right"></use>
                    </svg>
                </div> -->
              </div>
            </button>  

            <h1>ОФИЦ. САЙТ ХК СОЧИ - БИЛЕТЫ НА <span class="mobile-hidden">ДОМАШНИЕ</span> МАТЧИ</h1>
<!--
            <div style="font-weight:600;text-align:justify;padding-bottom:5px">
              В связи с распоряжением губернатора Челябинской области сообщаем, что начиная с 25 сентября при посещении домашних матчей «ХК Сочи» ПО БИЛЕТАМ – вам необходимо иметь с собой личный QR-код вакцинации от COVID-19, 
                        или свежий отрицательный ПЦР-тест, или паспорт вакцинации, а также документ, удостоверяющий личность (паспорт или водительское удостоверение). 
                        QR-код вакцинации, а также паспорт вакцины можно скачать с портала Госуслуги. Надеемся на ваше понимание!

            </div>
-->
            <div style="font-weight:500;text-align:justify;padding-bottom:16px">
              Открыта продажа билетов на матчи клуба в Фонбет Чемпионате КХЛ сезона 2026/2027
            </div>

            <div v-if="!isMobile()" class="choice-ticket__additional">
              <div class="choice-ticket__additional-mobile">
                <!--<button class="choice-ticket__additional-button" type="button">
                  <svg>
                    <use xlink:href="#ic_info"></use
                  </svg>
                  <span>Условия продажи билетов</span>
                </button>-->
                <!--Класс open у контейнера попапа делает его видимым-->
                <div class="choice-ticket__additional-popup">
                  <div class="wrapper">
                    <button class="close" type="button"></button>
                    <div class="additional-popup-content">
                      <!--<h3>Условия продажи билетов</h3>-->
                      <p>Продажа билетов на&nbsp;все домашние матчи игрового сезона открыта с&nbsp;10&nbsp;августа.</p>
                      <!--
                      <p class="bold-blue">Купить билеты заранее дешевле, чем в&nbsp;день матча.</p>
                      -->
                    </div>
                  </div>
                </div>
              </div>
              <!--
              <p class="desktop-text desktop-text--margin-bottom">
                Продажа билетов на все домашние матчи игрового сезона открыта с 1 сентября.
              </p>
              -->
              <!--
              <p class="desktop-text desktop-text--margin-right bold-blue">
                Купить билеты заранее дешевле, чем в день матча.
              </p>
              -->
              <a class="choice-ticket__additional-link" href="https://hcsochi.ru/media/news/biletnaya-programma-na-sezon-2026-2027/" target="_blank">
                <svg>
                    <use xlink:href="#ic_info"></use>
                </svg>
                <span>Билетная программа 2026-2027</span>
              </a>
            </div>
            <div v-else class="choice-ticket__additional-mobile">
              <div class="choice-ticket__additional-mobile">
                <!--<button class="choice-ticket__additional-button" type="button">
                  <svg>
                    <use xlink:href="#ic_info"></use>
                  </svg>
                  <span>Условия продажи билетов</span>
                </button>-->
                <!--Класс open у контейнера попапа делает его видимым-->
                <div class="choice-ticket__additional-popup">
                  <div class="wrapper">
                    <button class="close" type="button"></button>
                    <div class="additional-popup-content">
                      <!--<h3>Условия продажи билетов</h3>-->
                      <p>Продажа билетов на&nbsp;все домашние матчи игрового сезона открыта с&nbsp;10&nbsp;августа.</p>
                      <!--
                      <p class="bold-blue">Купить билеты заранее дешевле, чем в&nbsp;день матча.</p>
                      -->
                    </div>
                  </div>
                </div>
              </div>
              <!--
              <p class="desktop-text desktop-text--margin-bottom">
                Продажа билетов на все домашние матчи игрового сезона открыта с 1 сентября.
              </p>
              -->
              <!--
              <p class="desktop-text desktop-text--margin-right bold-blue">
                Купить билеты заранее дешевле, чем в день матча.
              </p>
              -->
              <a class="choice-ticket__additional-link" href="https://hcsochi.ru/media/news/biletnaya-programma-na-sezon-2026-2027/" target="_blank">
                <svg>
                    <use xlink:href="#ic_info"></use>
                </svg>
                <span>Билетная программа 2026-2027</span>
              </a>
            </div>

            <div v-if="allowedAllCalendar && allowedAllCalendar.length" class="new-items" style="margin-bottom: 16px;">
              <div  class="new-month">
                <ul class="choice-ticket__months" style="padding: 0; margin-bottom: 0;">
                  <li class="choice-ticket__month"  :class="{active: calendar.monthText === activeMonth}"
                                                    v-for="calendar in allowedAllCalendar" :key="calendar.monthText">
                    <button @click="getActiveMonth(calendar.monthText)" type="button">{{ calendar.monthName }}</button>
                  </li> 
                  
                </ul>
                <div class="new-button-games">
                    <div class="choice-ticket__slider-downloads" >
                      <a class="choice-ticket__slider-link" style="background-color: #F4F5FB;" href="/resources/files/HC_Sochi_2026_27.pdf" target="_blank">
                        <svg>
                          <use xlink:href="#ic_download"></use>
                        </svg>
                        Скачать расписание матчей
                      </a>
                    </div>
                  </div>
              </div>  
              <div class="choice-ticket__slider">
                <EventCards 
                  :allCalendar="otherAllCalendars" 
                  :activeMonth="activeMonth"
                />
              </div>
            </div>
<!--
            <div v-if="mhlAllCalendar && mhlAllCalendar.length" class="new-items">
              <div  class="new-month">
                <ul class="choice-ticket__months" style="padding: 0; margin-bottom: 0;">
                  <li class="choice-ticket__month"  :class="{active: calendar.monthText === activeMonthMhl}"
                                                    v-for="calendar in mhlAllCalendar" :key="calendar.monthText">
                    <button @click="getActiveMonthMhl(calendar.monthText)" type="button">{{ calendar.monthName }}</button>
                  </li> 
                  
                </ul>
                <div class="new-button-games">
                    <div class="choice-ticket__slider-downloads" >
                      <a class="choice-ticket__slider-link" style="background-color: #F4F5FB;" href="/resources/files/mhl_2026-27.jpg" target="_blank">
                        <svg>
                          <use xlink:href="#ic_download"></use>
                        </svg>
                        Скачать расписание матчей
                      </a>
                    </div>
                  </div>
              </div>  
              <div class="choice-ticket__slider">
                <EventCards 
                  :allCalendar="mhlAllCalendars" 
                  :activeMonth="activeMonthMhl"
                />
              </div>
            </div>
-->
            <div class="choice-ticket__bottom">
              <Questions 
              :calendarQuant="allowedAllCalendar.length"/>
            </div>
          </div>
        </div>
      </div>
      <TicketsPopupOrder 
        v-if="isTicketsPopupShown"
        @closeTicketsPopup="closeTicketsPopup"
        @stopTicketsPopupLoading="stopTicketsPopupLoading" 
        :orderReservedSeats="reservedSeats"
        :principalInfo="principalInfo"
      />
    </div>
    <ErrorPopup
      v-if="isErrorPopupShown"
      @closeErrorPopup="closeErrorPopup"
      :errorMessage="errorMessage"
    />
  </div>
</div>
</template>

<script>
import { calendarMapper } from '@/store/modules/calendar';
import {authorizationMapper} from "@/store/modules/authorization";

import { HalfCircleSpinner } from 'epic-spinners';
import EventCards from './EventCards.vue';
import Questions from './Questions.vue';
import TicketsPopupOrder from './TicketsPopupOrder.vue';
import ErrorPopup from './ErrorPopup.vue';

export default {
  name: 'Content',
  components: {
    HalfCircleSpinner,
    EventCards,
    Questions,
    TicketsPopupOrder,
    ErrorPopup
  },
  data() {
    return {
      activeMonth: '',
      activeMonthMhl: '',
      isTicketsPopupShown: false,
      isErrorPopupShown: false,
      errorMessage: '',
      isScrollOver: false,
      isTicketsPopupLoading: false,
      isContentLoading: false,
      mhlAllCalendars: [],
      otherAllCalendars: [],
    }
  },
  async mounted() {
    try {
      this.isContentLoading = true,
      await this.getAllCalendar();
    } catch(error) {
      if (error.status === 502) {
        this.errorMessage = "Ошибка связи с сервером.";
        this.isErrorPopupShown = true;
      }
    } finally {
      this.isContentLoading = false; 
    }
    await this.getReservedSeatsList();
    this.activeMonth = this.allowedAllCalendar[0]?.monthText;
    this.activeMonthMhl = this.mhlAllCalendar[0]?.monthText;
    // Setup the event listener and execute it once in case we are already scrolled
    window.addEventListener('scroll', this.scrollHandler);
    this.scrollHandler();
    
  },
  computed: {
    ...calendarMapper.mapGetters(['allCalendar', 'reservedSeats', 'bonuses']),
    ...authorizationMapper.mapGetters(['userInfo', 'principalInfo']),
    allowedAllCalendar() {
      const allowed = [];
      const allCalendar = this.allCalendar;

      // for (let i = 0; i < allCalendar.length; i++) {
      //   if(allCalendar[i].webTypes[0].calendars.find(
      //     calendar => calendar.algorithmSaleId == 510 || 
      //     (calendar.algorithmSaleId == 520 && calendar.seasonLocationName == 'MINI'))) {
      //     allowed.push(allCalendar[i]);
      //   }
      // }

      for (let i = 0; i < allCalendar.length; i++) {
        const types = [];
        for (let n = 0; n < allCalendar[i].webTypes.length; n++) {
          if(allCalendar[i].webTypes[n].webTypeId != 2 &&
            allCalendar[i].webTypes[n].calendars.find(
            calendar => calendar.algorithmSaleId == 510 || 
            (calendar.algorithmSaleId == 520 && calendar.seasonLocationName == 'MINI'))
          ) {
            types.push(allCalendar[i].webTypes[n]);
          }
        }

        if (types.length > 0) {
          const x = {"monthName":allCalendar[i].monthName,"monthText":allCalendar[i].monthText, "webTypes": types};
          allowed.push(x);
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.otherAllCalendars = allowed;
        }
        
      }
      return allowed;
    },
    mhlAllCalendar() {
      const allowed = [];
      const allCalendar = this.allCalendar;
      for (let i = 0; i < allCalendar.length; i++) {
        const types = [];
        for (let n = 0; n < allCalendar[i].webTypes.length; n++) {
          if(allCalendar[i].webTypes[n].webTypeId === 2 &&
            allCalendar[i].webTypes[n].calendars.find(
            calendar => calendar.algorithmSaleId == 510 || 
            (calendar.algorithmSaleId == 520 && calendar.seasonLocationName == 'MINI'))
          ) {
            types.push(allCalendar[i].webTypes[n]);
          }
        }

        if (types.length > 0) {
          const x = {"monthName":allCalendar[i].monthName,"monthText":allCalendar[i].monthText, "webTypes": types};
          allowed.push(x);
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.mhlAllCalendars = allowed;
        }
      }
      return allowed;
    },
    userInfoId() {
      return this.userInfo?.userId;
    },
    basketQuantity() {
      return this.reservedSeats && this.reservedSeats instanceof Array ? this.reservedSeats.reduce((accumulator, {quantity}) => {
        return accumulator + quantity;
      }, 0) : 0
    },
    basketPrice() {
      return this.reservedSeats && this.reservedSeats instanceof Array ? this.reservedSeats.reduce((accumulator, {price}) => {
        return accumulator + Number(price);
      }, 0) : 0
    },
    basketCalendar() {
      return Object.keys(
          this.reservedSeats && this.reservedSeats instanceof Array ? this.reservedSeats.reduce((accumulator, {calendarId}) => {
            accumulator[calendarId] = 1;
            return accumulator;
          }, {}) : {}).length;
    }  
  },  
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler);
  },

  methods: {
    ...calendarMapper.mapActions(['getAllCalendar', 'getReservedSeatsList', 'getAvailCalendarList']),
    getActiveMonth(monthText) {
      this.activeMonth = monthText;
    },
      getActiveMonthMhl(monthText) {
      this.activeMonthMhl = monthText;
    },
    stopTicketsPopupLoading(isLoading) {
      this.isTicketsPopupLoading = isLoading;
    },
    closeErrorPopup(isShowModal) {
      this.isErrorPopupShown = isShowModal;
    },
    async schemeClick(event) {
      const authorizedUserEmail = this.userInfo.userEmail;

      if (!authorizedUserEmail) {
        return this.isAuthorizationModalShown = true;
      }

      if (event.target.className.includes('seat available')) {
        const reserveInfo = {
          "quantity": 1,
          "seasonIds": [],
          "seatId": event.target.id,
          "categoryId": 1,
        }

        await this.reserveSeat({calendarId: this.gameInfo.id, reserveInfo});
        const node = document.getElementById(reserveInfo.seatId);
        if (node) {
          node.classList.add('reserved');
          node.classList.remove('available');
        }
      } else if (event.target.className.includes('seat reserved')) {
        const unreserveInfo = {
          quantity: 1,
          seatId: event.target.id
        }
        await this.unreserveSeat({calendarId: this.gameInfo.id, unreserveInfo});
        const node = document.getElementById(unreserveInfo.seatId);
        if (node) {
          node.classList.add('available');
          node.classList.remove('reserved');
        }
      }
    },  
    showTicketsPopup() {
      this.isTicketsPopupShown = true;

      if(!this.bonuses) {
        this.isTicketsPopupLoading = true;
      }
    },
    closeTicketsPopup(isShowTicketsPopup) {
      this.isTicketsPopupShown = isShowTicketsPopup;
    },
    scrollHandler() {
      this.isScrollOver = window.pageYOffset > 80;
    },
      isMobile: function() {	
      var check = false;
      // eslint-disable-next-line
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
    }
  },

}
</script>

<style scoped lang="scss">
 .all {
  min-height: calc(100vh - 176px - 170px);
  @media (max-width: 1279px) {
    min-height: calc(100vh - 88px - 170px);
    }
  @media (max-width: 1023px) {
    min-height: calc(100vh - 88px - 370px);
    }
  @media (max-width: 767px) {
    min-height: calc(100vh - 88px - 497px);
    }
 }
  .new-items {
    border-radius: 47px;
    background: rgba(217, 217, 217, 0.10);
    box-shadow: 0px 4px 20px 0px rgb(0 0 0 / 10%);
    backdrop-filter: blur(30px);
    padding: 50px;
    @media (max-width: 768px) {
      padding: 20px;
      border-radius: 16px;
    }
  }
  .new-month {
    display: flex; 
    justify-content: space-between; 
    margin-bottom: 46px;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .new-button-games {
    margin-left: 20px;
    min-width: 270px;
    @media (max-width: 768px) {
      margin-left: 0;
      margin-top: 20px;
    }
  }
  .tickets-popup-loader {
    position: absolute;
    left: 45%;
    top: 25%;
    z-index: 10;

    @media (max-width: 1279px) {
      display: none;
    }
  }
</style>

<!--<style lang="scss" src="@/styles/Content.scss">
</style>-->
